// App entry for lean Vite config
// Import any global polyfills or initializations here if needed
// Then import your existing modules in order or discover them dynamically.

// Option A: Explicit ordered imports
// import './modules/foo.js';
// import './modules/bar.js';
// import './scripts/scripts.js';

// Option B: Auto-discover modules (sorted by path for stable order)
const modules = import.meta.glob('./modules/*.js', { eager: true });
Object.keys(modules)
    .sort()
    .forEach((key) => {
        // modules[key] is already evaluated due to eager: true
    });

// Always include your scripts tail file last
import './scripts/scripts.js';
